/**
 * Contact: the headline is the route's own line; faqEyebrow, faqSub and the form copy are the plate
 * and the form beside it (v1 src/components/ContactGrid.tsx). Change the words here, never in the components.
 */
export const contactPage = {
  eyebrow: 'FAQs / Contact',
  titleThin: 'Let’s get your systems',
  titleBold: 'running smoothly.',
  lede: 'Tell me what’s going on in your HighLevel account. I’ll reply by email, or you can book a call straight away.',
  faqEyebrow: 'FAQs',
  faqTitle: 'Quick answers',
  faqSub: 'Still have one? Write below.',
  cardTitle: 'Send me a message',
  cardBody: 'What do you need help with? What are you working with today? Two or three lines is enough.',
  bookCall: 'Book a call',
}

/**
 * The form. With VITE_CONTACT_ENDPOINT set, Send posts the message as JSON to it (HighLevel inbox);
 * without it, or if that post fails to reach the server, Send opens the visitor's own mail app.
 */
export const contactForm = {
  first: 'First name',
  last: 'Last name',
  email: 'Email',
  message: 'Tell me more about your business',
  phFirst: 'First name',
  phLast: 'Last name',
  phEmail: 'you@yourbusiness.com',
  phMessage: 'What do you need help with? What are you working with today?',
  send: 'Send message',
  sending: 'Sending',
  hint: 'Goes straight to my HighLevel inbox.',
  hintMail: 'This form opens your own email app. Nothing is sent to or stored on this site.',
  error: 'Add your name, a real email, and a short note.',
  failed: 'That did not go through. Email me directly instead.',
  // Sent through the endpoint.
  postedTitle: 'Got it.',
  postedBody: 'It is in my inbox and on my phone. You will hear back within one business day.',
  // Handed to the mail app.
  sentTitle: 'Your mail app has it.',
  sentBody: 'The message is laid out and addressed. Press send there and you will hear back within one business day.',
  // The fallback for a visitor whose browser has no mail app set up.
  noMailApp: 'No mail app opened? Write to',
  copy: 'Copy message',
  copied: 'Copied',
  again: 'Write another',
}

/** /thank-you (v1 src/components/ThankYou.tsx): kept out of search, sends the visitor home after a few seconds. */
export const thankYouPage = {
  eyebrow: 'Message received',
  titleThin: 'Got it.',
  titleBold: 'Talk soon.',
  lede: 'I’ll review your message and follow up within 24 hours with next steps and a booking link. Check your inbox, and your spam folder just in case.',
  redirectSeconds: 5,
  redirecting: 'Redirecting you home in',
  home: 'Go home now',
}
